<template>
  <ClientOnly>
    <Teleport to="body">
      <transition name="fade">
        <div v-show="show" class="nb-container">
          <div :class="['notification-toast', bgColorClass]">
            <!-- X-Button oben rechts -->
            <button class="close-btn" aria-label="Close" @click="hide">
              ✕
            </button>

            <!-- Nachricht -->
            <p
              role="status"
              aria-live="polite"
              aria-atomic="true"
              class="font-semibold text-center"
            >
              {{ message }}
            </p>
          </div>
        </div>
      </transition>
    </Teleport>
  </ClientOnly>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
import { useNotificationBarStore } from '@/store/notificationbar';

const store = useNotificationBarStore();
const show = ref(false);
const message = ref('');
const bgColorClass = ref('bg-green-500');
let timeoutHandle = null;

// Farbzuordnung — Tailwind-safe, da alle Klassen hier statisch vorkommen
const colorMap = {
  green: 'bg-green-500',
  red: 'bg-red-600',
  yellow: 'bg-yellow-400'
};

const showNotification = (content) => {
  if (!content) return;
  message.value = content;
  bgColorClass.value = colorMap[store.color] || 'bg-green-500';
  show.value = true;

  if (timeoutHandle) clearTimeout(timeoutHandle);
  timeoutHandle = setTimeout(() => hide(), 4000);
};

const hide = () => {
  show.value = false;
  if (timeoutHandle) clearTimeout(timeoutHandle);
};

watch(
  () => store.tick,
  () => showNotification(store.content),
  { immediate: true }
);

onBeforeUnmount(() => {
  if (timeoutHandle) clearTimeout(timeoutHandle);
});
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";

/* === BASE CONTAINER === */
.nb-container {
  @apply fixed left-0 w-full flex justify-center z-[1100];
  top: calc(5rem + var(--campaign-height, 0px));
  max-height: calc(100dvh - 5rem - var(--campaign-height, 0px) - 16px);
  overflow-y: auto;
}

/* === TOAST BOX === */
.notification-toast {
  @apply relative opacity-90 text-white rounded-xl shadow-xl max-w-lg px-6 py-4 flex flex-col justify-center items-center transition-all duration-200;
}

/* === CLOSE BUTTON (X) === */
.close-btn {
  @apply absolute text-xs top-2 right-3 text-white text-lg leading-none hover:text-neutral-300 transition-colors;
}

/* === ANIMATIONS === */
.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
